<template>
  <div class="layview">
    <div class="header" style="width: 100%;">
      <div class="header-wrap radius">
        <h1 class="top-title"><i class="fa fa-table" aria-hidden="true"></i>全员日报</h1>
      </div>
    </div>
    <div class="viewmain">
      <avue-form ref="form" :option="option" v-model="form" @submit="submit">
        <template slot-scope="{row}" slot="menuButton">
          <el-button type="text" @click="getdqrw">获取当前任务</el-button>
        </template>
        <template slot-scope="{row}" slot="ZRW">
          <el-tooltip :content="row.ZRW" placement="top">
            <el-input :value="row.ZRW" size="small" placeholder="请选择二级任务" disabled></el-input>
          </el-tooltip>
        </template>
        <template slot-scope="{row}" slot="XZEJRW">
          <selectDialogeData :datas="row.XZEJRW" @onChecked="handleCheckedSelect($event, row)"></selectDialogeData>
        </template>
        <!-- <template slot-scope="{size}" slot="menuForm">
          <el-button type="success" :size="size" @click="seavForm(form)">保存</el-button>
          <el-button type="primary" :size="size" @click="$refs.form.submit()">提交表单</el-button>
        </template> -->
      </avue-form>
    </div>
  </div>
</template>
<script>
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
import selectDialogeData from '@/portal/other/dataPortal/components/selectData.vue'
export default {
  mixins: [crudPageMinix],
  components: { selectDialogeData },
  data() {
    return {
      sjrw: '',
      visible: false,
      sjh: '',
      txrq: '',
      ProcessKey: {},
      userInfo: {},
      form: {},
      option: {
        emptyBtn: false,
        // submitBtn: false,
        group: [
          {
            label: '基础信息',
            arrow: false,
            prop: 'jcxx',
            column: [
              {
                label: '姓名',
                prop: 'XM',
                span: 6,
                disabled: true
              },
              {
                label: '部门',
                prop: 'orgId',
                type: 'select',
                dicData: [],
                props: {
                  label: 'name',
                  value: 'id'
                },
                span: 6
              },
              {
                label: '手机号',
                prop: 'SJH',
                span: 6,
                disabled: true
              },
              {
                label: '填写日期',
                prop: 'TXRQ',
                span: 6,
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                change: ({ value }) => {
                  this.txrq = value
                }
              }
            ]
          },
          {
            label: '任务信息',
            arrow: false,
            prop: 'rwxx',
            labelPosition: 'top',
            column: [
              {
                label: '',
                prop: 'menuButton',
                formslot: true
              },
              {
                label: '任务列表',
                prop: 'RWXXZBD',
                type: 'dynamic',
                span: 24,
                children: {
                  align: 'left',
                  page: false,
                  headerAlign: 'center',
                  rowAdd: (done) => {
                    // this.$message.success('新增回调')
                    done({
                      RWLX: [],
                      ZRW: '',
                      XZEJRW: [],
                      // SJRWSX: this.sjrw,
                      SRW: '',
                      DRRW: '',
                      DRGRGS: '',
                      SRWJD: '',
                      bz: ''
                    })
                  },
                  rowDel: (row, done) => {
                    // this.$message.success('删除回调' + JSON.stringify(row))
                    done()
                    // console.log(row)
                  },
                  column: [
                    {
                      label: '任务类型',
                      prop: 'RWLX',
                      type: 'select',
                      filterable: true,
                      minWidth: 160,
                      dicData: [],
                      props: {
                        label: 'lbmc',
                        value: 'id'
                      }
                    },
                    {
                      label: '一级任务',
                      prop: 'ZRW',
                      readonly: true,
                      minWidth: 160,
                      width: 160,
                      formslot: true
                    },
                    {
                      label: '二级任务',
                      prop: 'XZEJRW',
                      formslot: true,
                      hide: false,
                      width: 200,
                      minWidth: 200
                    },
                    // {
                    //   label: '三级任务属性',
                    //   prop: 'SJRWSX',
                    //   minWidth: 180,
                    //   dicData: [],
                    //   type: 'select',
                    //   props: {
                    //     label: 'itemValue',
                    //     value: 'itemCode'
                    //   }
                    // },
                    {
                      label: '四级任务',
                      prop: 'SRW',
                      minWidth: 300
                    },
                    {
                      label: '完成情况',
                      prop: 'DRRW',
                      type: 'select',
                      minWidth: 140,
                      dicData: [
                        {
                          label: '已完成',
                          value: '已完成'
                        },
                        {
                          label: '进行中',
                          value: '进行中'
                        },
                        {
                          label: '延期',
                          value: '延期'
                        },
                        {
                          label: '暂停',
                          value: '暂停'
                        },
                        {
                          label: '终止',
                          value: '终止'
                        }
                      ]
                    },
                    {
                      label: '工时(H)',
                      prop: 'DRGRGS',
                      type: 'number',
                      minWidth: 140
                    },
                    {
                      label: '进度(%)',
                      prop: 'SRWJD',
                      type: 'number',
                      minWidth: 140
                    },
                    {
                      label: '备注',
                      prop: 'bz',
                      minWidth: 300
                    }
                  ]
                }
              },
              {
                label: '心得',
                prop: 'XD',
                type: 'textarea',
                maxlength: '200',
                span: 24,
                showWordLimit: true,
                placeholder: '请输入心得, 不少于100字',
                rules: [{
                  required: true,
                  message: '请输入心得, 不少于100字',
                  trigger: 'blur'
                }]
              }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    let txrq = year + '-' + month + '-' + day
    this.startProcess()
    this.getUserInfo(txrq)
    // this.getorgId()
    this.$http.post('/fighter-workflow-saas/xrbManager/queryTaskType', null, {
      params: {
        pageNum: 1,
        pageSize: 999
      }
    }).then(response => {
      let list = response.data.records
      this.$set(this.option.group[1].column[1].children.column[this.findArray(this.option.group[1].column[1].children.column, 'RWLX', 'prop')], 'dicData', list)
    })
    // 需求类型
    // this.$http.post('/fighter-workflow-saas/rwxxzd/listTaskProperties').then(res => {
    //   this.sjrw = res.data[9].itemCode
    //   this.$set(this.option.group[1].column[1].children.column[this.findArray(this.option.group[1].column[1].children.column, 'SJRWSX', 'prop')], 'dicData', res.data)
    // })
  },
  methods: {
    startProcess() {
      this.$http.post('/fighter-workflow-saas/flow-ext/start-process-instance-by-key', {}, {
        params: {
          processDefinitionKey: 'XRBLC'
        }
      }).then(response => {
        this.ProcessKey = response.data
      })
    },
    getUserInfo(txrq) {
      this.$http.get('/fighter-lightportal-saas/personalCenter/getPersonalCenter').then(response => {
        this.$set(this.option.group[0].column[this.findArray(this.option.group[0].column, 'orgId', 'prop')], 'dicData', response.data.subject.orgList)
        if (response.data.subject.orgList.length !== 0) {
          this.form.orgId = response.data.subject.orgList[0].id
        }
        this.loadData(response.data.subject.loginName, txrq)
        this.userInfo = response.data.subject
      })
    },
    loadData(sjh, txrq) {
      this.$http.post('/XrbhzlcController/listRbbdxxBySjhAndRq', null, {
        params: {
          sjh: sjh,
          rq: txrq
        }
      }).then(response => {
        if (response.data.length === 0) {
          this.form.XM = this.userInfo.name
          this.form.SJH = this.userInfo.loginName
          this.form.TXRQ = txrq
          this.form.RWXXZBD = {}
          this.form.XD = ''
        } else {
          this.form = response.data[0]
        }
      })
    },
    handleCheckedSelect(datas, row) {
      row.XZEJRW = []
      if (datas && datas.length > 0) {
        for (let i = 0; i < datas.length; i++) {
          row.XZEJRW.push({ name: datas[i].ejrwmc, value: datas[i].ejrwid })
          row.ZRWID = datas[i].yjrwid
          row.ZRW = datas[i].yjrwmc
          row.ZZRWID = datas[i].ejrwid
          row.ZZRW = datas[i].ejrwmc
        }
      } else {
        row.XZEJRW = []
        row.ZRWID = ''
        row.ZRW = ''
        row.ZZRWID = ''
        row.ZZRW = ''
      }
    },
    // 获取当前任务
    getdqrw() {
      this.$http.post('/fighter-workflow-saas/rwxxzd/listCurrentTask').then(res => {
        if (res.data.length === 0) {
          this.$message.warning('当前没有任务')
        } else {
          this.form.RWXXZBD.push(...res.data)
        }
      })
    },
    submit(form, done) {
      let setData = {
        orgId: form.orgId,
        SJH: form.SJH,
        TXRQ: form.TXRQ,
        XM: form.XM,
        XD: form.XD,
        RWXXZBD: form.RWXXZBD,
        ZGS: eval(form.RWXXZBD.map((e) => e.DRGRGS).join('+')),
        processCode: '',
        processInstanceId: this.ProcessKey.processInstanceId,
        taskId: this.ProcessKey.taskId
      }
      this.$http.post('/fighter-workflow-saas/form-instance/save', setData, {
        params: {
          isSubmitProcess: true,
          formId: this.ProcessKey.formKeyList[0]
        }
      }, {}).then(response => {
        this.$message.success('提交成功')
        this.form.RWXXZBD = []
        this.form.XD = ''
        setTimeout(() => {
          done()
        }, 3000)
        this.startProcess()
        this.$router.push(
          {
            path: `/applyForm?businessKey=${response.data.id}&processInstanceId=&taskId=&formId=` + this.ProcessKey.formKeyList[0] + `&pageKey=VIEW&showNav=no&isIframe=true&isHiddenBtn=1`
          }
        )
      }).catch(response => {
        this.$message.warning(response.msg)
      }).finally(() => {
        this.TABLE_LOADING = false // 表格转圈
        typeof done === 'function' && done()
      })
    }
  },
  watch: {
    txrq(newval, oldval) {
      if (oldval !== undefined && oldval !== '') {
        if (Date.parse(newval) !== Date.parse(oldval)) {
          this.loadData(this.$store.getters.userInfo.subject.loginName, newval)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.avue-group__title) {
  font-size: 1.1rem;
  font-weight: 600;
}

:deep(.el-button--mini.is-circle) {
  padding: 6px;
}

:deep(.el-input__inner) {
  font-weight: bolder !important;
}

:deep(.el-textarea__inner) {
  font-weight: bolder !important;
}

:deep(.el-input.is-disabled .el-input__inner) {
  color: #606266;
}

:deep(.el-textarea.is-disabled .el-textarea__inner) {
  color: #606266;
}

:deep(.el-checkbox__input.is-disabled + span.el-checkbox__label) {
  color: #606266;
}

:deep(.el-radio__input.is-disabled + span.el-radio__label) {
  color: #606266;
}

:deep(.el-range-editor.is-disabled input) {
  color: #606266;
}

.layview {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  //   background-color: #f0f2f5;
}

// 顶部的标题
.header {
  width: 100%;
  box-sizing: border-box;
  //   margin-bottom: 10px;
}

.radius {
  border-radius: 7px;
}

.header-wrap {
  display: flex;
  align-items: center;
  height: 60px;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
  background: #fff;
  box-sizing: border-box;
  padding: 0 30px;
  width: 100%;
  box-shadow: 2px 2px 2px 0px rgba(220, 220, 220, 0.5);
}

h1.top-title {
  margin: 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 36px;
  color: #409eff;
  margin-right: auto;
}

.viewmain {
  :deep(.avue-group .el-collapse-item__wrap) {
    border: 0;
    padding: 0 20px;
  }

  :deep(.avue-group .el-collapse) {
    border: 0;
    margin-bottom: 10px;
    border-radius: 7px;
    overflow: hidden;
  }

  :deep(.avue-group__header) {
    padding-left: 30px;
  }
  :deep(.el-tooltip .el-input__inner) {
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; // 默认不换行；
  }
}
</style>
